import { Record as record } from 'immutable';

import { construct, fields, resolve } from '../../helpers/LinkMapper';

const defaults = {
    id: null,
    amount: null,
    amountRefunded: null,
    originalAmount: null,
    voucherId: null,
    voucherType: null,
    created: null,
    refunded: null,
    latest: null,
    campaignName: null,
    campaignCode: null,
    campaignTerms: null,
};

export default class WarrantPayment extends record(defaults) {

    static fromJSON (json = {}) {
        const campaign = json.campaign || {};
        return construct(WarrantPayment, json, {
            id: fields.number,
            amount: fields.number,
            amountRefunded: fields.number,
            originalAmount: fields.number,
            voucherId: fields.number,
            voucherType: fields.string,
            created: fields.datetime,
            refunded: fields.boolean,
            latest: fields.boolean,
            campaignName: () => resolve(campaign.name).with(String),
            campaignCode: () => resolve(campaign.code).with(String),
            campaignTerms: () => resolve(campaign.terms).with(String),
        });

    }

    isLightPromo () {
        return this.voucherType === 'LightPromo';
    }

    hasLatestPayment () {
        return this.latest;
    }

    getPaymentAmount () {
        return this.amount;
    }

}
